import type { GetStaticProps, NextPage } from "next";
import { LocalizedPage } from "@/types/PropTypes";
import { locale } from "@/helpers/translationTexts";
import BaseHeader from "@/components/BaseHeader";

import languages from "@/constants/languages.json";
import Login from "@/components/Login";

const Page: NextPage<LocalizedPage> = ({ languageCode }) => {
  const currentLocale = locale(languageCode);

  return (
    <div>
      <BaseHeader
        title={currentLocale.loginMetaTitle}
        description={currentLocale.loginMetaDescription}
      />
      <Login />
    </div>
  );
};

export async function getStaticPaths() {
  const paths = languages.map((language: string) => ({
    params: { lang: language },
  }));

  return { paths, fallback: "blocking" };
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  try {
    return { props: { languageCode: params?.lang } };
  } catch (error) {
    return { notFound: true };
  }
};

export default Page;
